import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { formatCurrency } from "@heartinz/finance";

export const FormatedSaleData = (sale) => {
  const convert = (value) =>
    formatCurrency(CurrencyConverter.toCurrency(value || 0, "INR"), "INR");

  return {
    ...sale,

    saledate: sale?.saledate,

    saleitems: sale?.saleitems?.map((item) => ({
      ...item,
      mrp: convert(item?.mrp),
      saleprice: convert(item?.saleprice),
      soldprice: convert(item?.soldprice),
      baseprice: convert(item?.baseprice),
      discount: convert(item?.discount),
      taxamount: convert(item?.taxamount),
      sgstAmount: convert(item?.sgstAmount),
      cgstAmount: convert(item?.cgstAmount),
      igstAmount: convert(item?.igstAmount),
      lineTotalMrp: convert(item?.lineTotalMrp),
      lineTotalSalePrice: convert(item?.lineTotalSalePrice),
      lineTotalSoldPrice: convert(item?.lineTotalSoldPrice),
      lineTotalDiscount: convert(item?.lineTotalDiscount),
      lineTotalBasePrice: convert(item?.lineTotalBasePrice),
      lineTotalTaxAmount: convert(item?.lineTotalTaxAmount),
      lineTotalSgstAmount: convert(item?.lineTotalSgstAmount),
      lineTotalCgstAmount: convert(item?.lineTotalCgstAmount),
      lineTotalIgstAmount: convert(item?.lineTotalIgstAmount),
      lineGrandTotal: convert(item?.lineGrandTotal),
      lineTotalLandingCost: convert(item?.lineTotalLandingCost),
    })),
    totalmrp: convert(sale?.totalmrp),
    totalsaleprice: convert(sale?.totalsaleprice),
    totalsoldprice: convert(sale?.totalsoldprice),
    totalbaseprice: convert(sale?.totalbaseprice),
    totaldiscount: convert(sale?.totaldiscount),
    totaltaxamount: convert(sale?.totaltaxamount),
    grandtotal: convert(sale?.grandtotal),
    sgstamount: convert(sale?.sgstamount),
    cgstamount: convert(sale?.cgstamount),
    igstamount: convert(sale?.igstamount),
    cashamount: sale?.cashamount,
    cashchange: sale?.cashchange,
    cashPaid: convert(sale?.cashamount - sale?.cashchange),
    cardamount: sale?.cardamount,
    cardchange: sale?.cardchange,
    cardPaid: convert(sale?.cardamount - sale?.cardchange),
    onlineamount: sale?.onlineamount,
    onlinechange: sale?.onlinechange,
    onlinePaid: convert(sale?.onlineamount - sale?.onlinechange),
    upiamount: sale?.upiamount,
    upichange: sale?.upichange,
    upiPaid: convert(sale?.upiamount - sale?.upichange),
    paylateramount: sale?.paylateramount,
    paylaterchange: sale?.paylaterchange,
    balanceDue: convert(sale?.paylateramount - sale?.paylaterchange),
    waveoffamount: sale?.waveoffamount,
    waveoffchange: sale?.waveoffchange,
    changeamount: sale?.changeamount,

    paidamount: convert(sale?.paidamount),
    paymentInfo: sale?.paymentInfo?.map((pay) => ({
      ...pay,
      amount: convert(pay?.amount),
    })),
  };
};
